import { Injectable } from '@angular/core';
import { Empresa } from '../clases/empresa';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class EmpresasService {


  private empresas$: BehaviorSubject<Empresa[]> = new BehaviorSubject<Empresa[]>([]);

  constructor(private _http: HttpClient) { }

  guardarEmpresas(empresa: Empresa) {
    const url = environment.URL_BASE + 'empresaAuthorization/save'
    return this._http.post(url, empresa)
  }


  listarEmpresas(obj: any) {
    const url = environment.URL_BASE + 'empresaAuthorization/filter'
    return this._http.post(url, obj).pipe(
      map( (res: any) => {
        this.empresas$.next(res.data);
        return res;
      })
    )
  }

  getEmpresas(){
    return this.empresas$;
  }

  getEmpresa(id: number | string){
    return this.getEmpresas().pipe(
      map( listaEmpresa => listaEmpresa.find(empresa => empresa.IdEmpresa === +id))
    );
  }

  listarEmpresasId(id: number) {
    const url = environment.URL_BASE + 'empresaAuthorization/get' + "?id=" + id;
    return this._http.get(url)
  }
}
